import { Component, OnInit, Inject } from '@angular/core';
import {  MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from "lodash-es";

@Component({
  selector: 'app-access-levels',
  templateUrl: './access-levels.component.html',
  styleUrls: ['./access-levels.component.css',
    '../../../../admin-dashboard/common-popup/common-popup.css']
})
export class AccessLevelsComponent {

  // "actions" gates the vending-machine "Test channel" button
  // (auth.service.ts's canPerformActions()) — was previously grantable only
  // by editing the Firestore doc directly.
  access = ['overview','products', 'setting','category', 'routines', 'lastConnection','orders','refund','productRegulering',"companyReportPermission","salesReport","campaignPermission",'support','shell','stocking','extraDeliveries','systemConfigs','actions'];

  selectedOptions = [];
  selectedOption;
  objectKeys = Object.keys;

  constructor(public dialogRef: MatDialogRef<AccessLevelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {

      data = _.values( _.keys(_.pickBy(data)));     
    this.selectedOptions = data
  }

  onNgModelChange($event) {
    this.selectedOption = $event;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
